import { tns } from "tiny-slider";

// Optional per-card image carousel (product gallery). Swipe only, with dots as
// a position indicator. When a product has no gallery the card just shows the
// featured image, so this only runs for cards that opt in.
function initCardGallery(id) {
	const container = document.querySelector(".card-gallery-" + id);
	if (!container || container.dataset.initialised === "true") {
		return;
	}
	container.dataset.initialised = "true";

	// Load the gallery images BEFORE initialising the slider. In loop mode tns
	// clones the first/last slides; if those are cloned while still lazy they
	// flash blank when you swipe around the loop. Sourcing the images first
	// means the clones inherit a real `src`.
	container.querySelectorAll("img[data-src]").forEach((img) => {
		if (!img.classList.contains("img-loaded")) {
			img.src = img.getAttribute("data-src");
			img.classList.add("img-loaded", "show");
		}
	});

	// No arrows; dots are kept as a position indicator (navigation is swipe).
	tns({
		container: ".card-gallery-" + id,
		mode: "carousel",
		items: 1,
		loop: true,
		autoplay: false,
		controls: false,
		nav: true,
		navPosition: "bottom",
		mouseDrag: true,
		lazyload: false,
	});
}

function initAllCardGalleries() {
	document.querySelectorAll(".card-gallery[data-gallery-id]").forEach((container) => {
		initCardGallery(container.dataset.galleryId);
	});
}

if (document.readyState !== "loading") {
	initAllCardGalleries();
} else {
	document.addEventListener("DOMContentLoaded", initAllCardGalleries);
}

window.initCardGallery = initCardGallery;
window.initAllCardGalleries = initAllCardGalleries;
